






























import { Prop, Component, Vue, Watch } from 'vue-property-decorator'
import { Action } from '@/api/model/action'
import { ActionType } from '@/api/types'
import { User } from '@/api/model/user'

@Component
export default class EditActionForm extends Vue {
    @Prop() readonly value!: Action
    initialAssignedTo: User[] = []

    @Watch('value', { immediate: true })
    updateInitialAssignedTo() {
        this.initialAssignedTo = [...this.value.assignedTo]
    }

    get actionAppointmentTypeOptions(): Array<{ label: string, value: string }> {
        return Action.availableAppointmentTypes.map(value => {
            return {
                label: this.$t(`action.appointmentType.${value}`).toString(),
                value,
            }
        })
    }

    get sortedUsers() {
        // Get assignable users
        const availableUsers = this.$currentCompany.getAvailableUsers({ branch: this.value.referral ? this.value.referral.assignedToBranch : null })

        // Get already assigned users
        this.initialAssignedTo.forEach((assignedUser: User) => {
            if (availableUsers.findIndex((availableUser: User) => availableUser.id === assignedUser.id) >= 0) {
                return
            }

            availableUsers.push(assignedUser)
        })

        // Sort users (current user first, other users by name)
        return availableUsers
            .sort((a: User, b: User) => {
                if (a.id === this.$currentUser.id) {
                    return -1
                }

                if (b.id === this.$currentUser.id) {
                    return 1
                }

                return a.name.localeCompare(b.name)
            })
    }

    get isAppointmentType() {
        return this.value.type === ActionType.MEETING
    }
}
